<template lang="pug">
AppSidebar.activities-location-sidebar(
  :id="sidebarId"
  :has-pull-btn="hasPullBtn"
  :visible="showSidebar"
  :dismiss-on-body-click="false"
  :class="selectedTab"
  @show="$emit('show')"
  @close="$emit('close')"
)
  DynamicScroller.scroller(
    :items="jobSites"
    :min-item-size="90"
  )
    template(#before)
      button.activities-sidebar-close.btn.btn-icon.close.ml-auto(
        type="button"
        aria-hidden="true"
        @click="$emit('close')"
      )
        i.hi.hi-close.hi-9

      AppTabs(
        compact
        :selected-tab="selectedTab"
        @change="onSelectedTab"
      )
        AppTab(
          label="Members"
          tab-id="members"
        )
          ActivitiesLocationSidebarMembersTab(
            :is-past="isPastView"
            @selected="onSelected('members', $event)"
          )
        AppTab(
          label="Job sites"
          tab-id="jobSites"
        )
          ActivitiesLocationSidebarJobSitesTab(
            v-model="sitesQuery"
            :query="sitesQuery"
            :sidebar-id="sidebarId"
            :has-job-sites="hasJobSites"
            @group-by-changed="onJobSitesGroupBy"
          )

    template(#default="{ item, index, active }")
      DynamicScrollerItem(
        v-show="selectedTab === 'jobSites'"
        :item="item"
        :active="active"
        :data-index="index"
      )
        ActivitiesLocationSelectJobSite(
          :job-site="item"
          :sidebar-id="sidebarId"
          @job-site-selected="onSelectSite"
        )
</template>
<script>
import { isMobile } from '~/mixins';
import { mapActions, mapGetters, mapState } from 'vuex';
import { get, lowerCase, sortBy } from 'lodash-es';
import { LOCATION_SITES_MODE } from '~/app_constants';
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';

export default {
  name: 'ActivitiesLocationSidebar',
  components: {
    DynamicScroller,
    DynamicScrollerItem,
  },
  mixins: [isMobile],
  props: {
    showSidebar: {
      type: Boolean,
      default: true,
    },
    hasPullBtn: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['show', 'close'],
  data: () => ({
    sitesQuery: '',
    selectedTab: 'members',
    jobSitesGroupBy: { id: 'lastVisited', text: 'Last visited' },
  }),
  computed: {
    ...mapState(['selectedSite', 'sitesViewMode', 'selectedMember']),
    ...mapGetters(['sites', 'isPastView', 'sitesByPartition']),
    sidebarId() {
      return 'activities-locations-sidebar';
    },
    hasJobSites() {
      return !!get(this.jobSites, 'length', 0);
    },
    jobSites() {
      const query = lowerCase(this.sitesQuery);
      const { visited } = this.sitesByPartition;
      const sites = this.sitesViewMode === LOCATION_SITES_MODE.VISITED ? visited : this.sites;
      const filteredSites = sites.filter((site) =>
        ['name', 'address'].some((key) => lowerCase(site[key]).includes(query)),
      );

      return sortBy(filteredSites, [
        (site) => (this.jobSitesGroupBy.id === 'alpha' ? site.name : site.last_visited_at),
      ]);
    },
  },
  watch: {
    selectedMember(member) {
      if (member && member.id) {
        const sidebar = document.getElementById(this.sidebarId);
        const listItem = document.getElementById(this.selectListItemId(member.id));

        if (sidebar && listItem) {
          sidebar.scrollTop = listItem.offsetTop;
        }

        this.onSelectedTab('members');
      }
    },
    selectedSite(site) {
      if (site && site.id) {
        this.onSelectedTab('jobSites');
      }
    },
  },
  mounted() {
    if (window.location.search) {
      const param = window.location.search.substring(1);

      if (param.includes('showVisitedJobSites')) {
        this.selectedTab = 'jobSites';
      }
    }
  },
  methods: {
    ...mapActions(['selectSite', 'clearSelected', 'showInfoWindow']),
    onSelected(tab, memberTrackedLocation = false) {
      if (this.isMobile && (tab === 'jobSites' || tab === 'members') && memberTrackedLocation) {
        this.$emit('close');
      }
    },
    onSelectedTab(tab) {
      this.selectedTab = tab;
    },
    selectListItemId(id) {
      return `select-list-item-${id}`;
    },
    onSelectSite(site) {
      if (site) {
        this.clearSelected();
        this.selectSite(site);
        this.showInfoWindow(true);
        this.onSelected('jobSites');
      }
    },
    onJobSitesGroupBy(newValue) {
      this.jobSitesGroupBy = newValue;
    },
  },
};
</script>
